//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import React, { useEffect, useState, useRef, useMemo, useCallback, memo, forwardRef, useImperativeHandle } from "react";
import { connect, useDispatch } from "react-redux";
import styled from "styled-components";
import {
  groupBy,
  filter,
  find,
  orderBy,
  map,
  flatMap,
  get,
  has,
  uniqBy,
} from "lodash";
import { Col, Row, Pagination } from "antd";
import StudentVisualsSkeleton from "components/UI/Skeltonloader/StudentVisualsSkeleton";
//  -- Constants ----------------------
import COLOR from "utils/constants/color";
import { handleListUserNotes } from "store/notes/thunks";
import {
  handleListUserSubmissionsByClass,
} from "store/submissions/thunks";

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import moment from "moment";
import AssignmentStatusStudent from "components/AssignmentStatusStudent";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import {
  useOrgTimezone,
  useParentOrgId,
} from "store/organizations/selectors";
import {
  nothingToSee,
} from "utils/assets/images";
import tableViewSvg from "../utils/assets/images/tableView.svg";
import {
  semeterDateByYear,
  getCurrenSem,
  getSem1EndDate,
  getSem2StartDate,
  isBeforTime,
  checkIsManualGradable,
  filterActiveTasks,
} from "utils/methods/math";
import { useResources } from "store/resources/selectors";
import { useServertime } from "store/servertime/selectors";
import "moment-timezone";
import { useComponentVisibleHook } from "utils/hooks";
import { useCurrentClass, useCurrentClassBook } from "store/classes/selectors";
import SentryWrap from 'components/Sentry';
import {
  isVideo,
  getUserAssignment,
  filterStudentSubmission,
} from "utils/lib/ebookHelper";
import { useExams } from "store/exams/selectors";
import { useStory } from "store/story/selectors";
import { useApExams } from "store/apexams/selectors";
import { useClassGameActivity } from "store/one_game/selectors";
import * as Sentry from "@sentry/react";
import { handleGetStudentAssignmentCount } from "store/users/thunks";
import StudentGradebook from "modules/StudentDashboardNew/StudentGradebook";
import { useUserAllowedBooks } from "store/books/selectors";
import { useCurrentClassActiveBooks } from "components/hooks/books/useCurrentClassActiveBooks";
import useBookCollection from "components/hooks/books/useBookCollection";
import useActiveStudentofParent from "components/hooks/parent/activeStudentofParent";
import dayjs from 'utils/dayjsConfig';
const ACTIVE_BTN_COLOR = `linear-gradient(90deg, #4F5FFE 0%, #9957ED 100%)`;
const DEACTIVE_BTN_COLOR = `linear-gradient(90deg, #10979D 0%, #10979D 100%)`;
const getBgColor = (isActive) =>
  isActive ? ACTIVE_BTN_COLOR : DEACTIVE_BTN_COLOR;
moment.updateLocale("en", {
  week: {
    dow: 1,
  },
});

// const config = {
//   chart: {
//     plotBackgroundColor: null,
//     plotBorderWidth: null,
//     plotShadow: false,
//     type: "pie",
//     marginTop: 0,
//     spacingLeft: 0,
//     spacingRight: 0,
//     spacingTop: 0,
//     height: 160,
//     animation: true,
//     backgroundColor: "transparent",
//   },
//   title: {
//     text: "",
//     align: "center",
//     verticalAlign: "middle",
//     y: 0,

//     style: {
//       fontWeight: 200,
//       fontSize: "24px",
//       color: "#fff",
//     },
//   },
//   tooltip: {
//     enabled: true,
//     formatter: function () {
//       return `${this.key ?? ""}` + ":" + this.y + "%";
//     },
//   },
//   plotOptions: {
//     series: {
//       animation: {
//         duration: 2000,
//       },
//     },
//     pie: {
//       cursor: "pointer",
//       dataLabels: {
//         enabled: false,
//       },
//       point: {
//         events: {
//           legendItemClick: () => false,
//         },
//       },
//       showInLegend: false,
//       borderWidth: 0,
//       colors: ["rgb(90,177,208)", "rgb(130,222,228)"],
//     },
//   },
//   series: [
//     {
//       innerSize: "67%",
//       data: [
//         { name: "Overall Grade", y: 1 },
//         { name: "", y: 1 },
//       ],
//     },
//   ],
// };

const config1 = {
  chart: {
    type: "pie",
    backgroundColor: "transparent",
    height: 116,
    width: 116,
    spacing: [0, 0, 0, 0],
  },
  title: {
    text: "75%",
    align: "center",
    verticalAlign: "middle",
    y: 10,
    style: {
      fontWeight: "bold",
      fontSize: "24px",
      color: "#000",
    },
  },
  tooltip: {
    enabled: false,
  },
  plotOptions: {
    pie: {
      dataLabels: {
        enabled: false,
      },
      startAngle: -90,
      endAngle: 270, // Makes it a full circle starting from top
      center: ["50%", "50%"],
      size: "100%",
      borderWidth: 0,
    },
  },
  colors: [
    {
      linearGradient: { x1: 0, y1: 1, x2: 1, y2: 0 },
      stops: [
        [0, "#ff4ddb"], // Bright pink
        [1, "#4c65f3"], // Blue
      ],
    },
    "#e9ecf6", // Light grey background
  ],
  series: [
    {
      type: "pie",
      innerSize: "80%",
      data: [{ y: 75 }, { y: 25 }],
    },
  ],
};
const DROPDOWN = [
  { value: "all", label: "All" },
  { value: "due_today", label: "Due Today" },
  { value: "due_this_week", label: "Due This Week" },
  { value: "due_past", label: "Past Due" },
  { value: "completed", label: "Completed" },
  { value: "incompleted", label: "Incomplete" },
  { value: "retakes", label: "Retake Available" },
  { value: "startToday", label: "Start Today" },
  { value: "missing_this_week", label: "Missing This Week" },
];

const DROPDOWNSORT = [
  { value: "all", label: "None" },
  { value: "oldest_to_newest", label: "Oldest to newest" },
  { value: "newest_to_oldest", label: "Newest to oldest" },
  { value: "alphabetical_order", label: "Alphabetical order" },
];
//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------

const Wrapper = styled.div`
  height: auto;
  margin-bottom: 40px;
  width: 100%;
`;

const OverallGradeTitle = styled.div`
  color: white;
  font-size: 28px;
  font-weight: 300;
  white-space: pre-line;
  margin-left: 60px;
`;
const SearchByTitle = styled(OverallGradeTitle)`
  color: #000;
  font-family: Arial;
  font-size: 17px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0px;
  margin-bottom: 10px;
`;

const FilterFieldLabel = styled(SearchByTitle)`
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 6px;
`;

const FilterField = styled.div`
  flex: 1;
  min-width: 0;
`;

const FILTER_STATUS_LABEL = "Status";
const FILTER_BOOK_LABEL = "Book";
const FILTER_SORT_LABEL = "Sort";

const WrapperSec1 = styled.div`
  filter: drop-shadow(0px 0px 2.54px rgba(0, 0, 0, 0.26));
  background: #fff;
  border-radius: 7px;
`;

const Dropdown = styled.button`
  width: 100%;
  height: 48px;
  background: #f4f5fa;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  border-width: 0px;
  cursor: pointer;
  justify-content: space-between;
  padding: 8px 15px;
  align-items: center;
`;
const DropdownTitle = styled.div`
  color: #000;
  font-family: Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.4;
  flex: 1;
  min-width: 0;
  text-align: left;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  @media (max-width: 767px) {
    font-size: 14px;
  }
`;
const BookDropdownTrigger = styled(Dropdown)`
  height: auto;
  min-height: 48px;
  padding: 10px 15px;
  align-items: center;
`;
const DropdownIcon = styled.div`
  margin-top: -2px;
`;
const DropdownContainer = styled.div`
  display: flex;
  position: relative;
  width: 100%;
`;
const DropdownContent = styled.div`
  display: ${(p) => (p.show ? "flex" : "none")};
  flex-direction: column;
  width: 100%;
  min-width: 100%;
  align-items: stretch;
  gap: 10px;
  padding: 14px 12px;
  top: 55px;
  border-radius: 7px;
  background: #fff;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
  z-index: 999999;
  position: absolute;
  box-sizing: border-box;
  max-height: 323px;
  overflow-y: auto;
  overflow-x: hidden;

  &.setDropDownHght button {
    margin: 0;
    height: auto;
    max-height: none;
    overflow: visible;
  }

  @media screen and (max-width: 680px) {
    right: 0px;
  }
`;
const DropdownItem = styled.button`
  color: ${(p) => (p.$isSelected ? "#fff" : "#000")};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: ${(p) => (p.$isBook ? "flex-start" : "center")};
  text-align: ${(p) => (p.$isBook ? "left" : "center")};
  font-family: Arial, sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: ${(p) => (p.$isSelected ? 600 : 400)};
  line-height: 1.5;
  height: auto;
  min-height: 52px;
  width: 100%;
  margin: 0;
  padding: 14px 14px;
  box-sizing: border-box;
  white-space: normal;
  overflow: visible;
  overflow-wrap: anywhere;
  word-break: break-word;
  flex-shrink: 0;
  border: 1px solid transparent;
  border-radius: 8px;
  background: ${(p) =>
    p.$isSelected
      ? "linear-gradient(90deg, #4d5ffe 0%, #9a57ed 100%)"
      : "linear-gradient(#f8f9fb, #f8f9fb) padding-box, linear-gradient(90deg, #4d5ffe 0%, #9a57ed 100%) border-box"};
  @media (max-width: 767px) {
    font-size: 14px;
    padding: 13px 12px;
    min-height: 48px;
  }
`;
const SectionContainer = styled.div`
  width: 100%;
  overflow-y: auto;

  & > * {
    content-visibility: auto;
    contain-intrinsic-size: auto 140px;
  }
`;

const PaginationFooter = styled.div`
  display: flex;
  justify-content: center;
  padding: 16px 12px 8px;
  border-top: 1px solid #eef0f6;
  background: #fff;
  border-radius: 0 0 7px 7px;
`;

const NoAssignmentImg = styled.img`
  height: 312px;
  width: initial;
  object-fit: initial;
`;

const Tab = styled.button`
  border: none;
  background-image: ${(p) => getBgColor(p.active)};
  cursor: pointer;
  font-size: 18px;
  font-weight: 600;
  outline: none;
  padding: 8px 0px;
  width: 204px;
  min-height: 50px;
  color: white;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: Arial;
  text-transform: capitalize;
  border-radius: 16px 16px 0px 0px;
  @media (max-width: 767px) {
    font-size: 13px;
    width: 133px;
  }
  @media (max-width: 467px) {
    font-size: 12px;
    width: 120px;
  }
  @media (max-width: 424px) {
    font-size: 10px;
    width: 108px;
  }
`;
//  ----------------------------------------------------------------------------
//  Component
//  ----------------------------------------------------------------------------
//
//  Admin class visuals
//
//  -- Description
//  Admin view class visuals
//
//  -- Props
//  ...
//
//  -- State
//  ...
//
//  -- Methods
//  ...
//
//  -- Usage
//
const getKey = (sem, year) =>
  `${sem == 1 ? "semester 1" : "semester 2"} - ${year}`;

const ACTIVITIES_PAGE_SIZE = 50;

const buildCompletedSubmissionIds = (submissions, userId) => {
  const completedIds = new Set();
  if (!submissions?.length || !userId) {
    return completedIds;
  }
  for (let i = 0; i < submissions.length; i += 1) {
    const submission = submissions[i];
    if (submission?.complete && submission?.user?.id === userId && submission?.assignmentId) {
      completedIds.add(submission.assignmentId);
    }
  }
  return completedIds;
};

const isAssignmentSubmitted = (assignment, completedIds) => {
  const activityId = assignment?.activityId;
  const quizId = assignment?.quizId;
  return (
    (activityId && completedIds.has(activityId)) ||
    (quizId && completedIds.has(quizId))
  );
};

const getCardData = (user_id, semData, submissions) => {
  const all_class_assignment = semData ?? [];
  const completedIds = buildCompletedSubmissionIds(submissions, user_id);
  let examinAssigned = 0;
  let unitExaminAssigned = 0;
  let activityAssigned = 0;
  let activityCompleted = 0;
  let pastDueActivity = 0;
  let examinCompleted = 0;
  let pastDueExamin = 0;
  let unitExaminCompleted = 0;
  let pastDueUnitExamin = 0;

  for (let i = 0; i < all_class_assignment.length; i += 1) {
    const k = all_class_assignment[i];
    const isExam = k?.data?.is_exam;
    const isUnitExam = k?.data?.is_unit_exam;
    const completed = isAssignmentSubmitted(k, completedIds);

    if (isExam) {
      examinAssigned += 1;
      examinCompleted += completed ? 1 : 0;
      if (!completed && isBeforTime(get(k, "dueDate")) && (!k.lateDate || isBeforTime(get(k, "lateDate")))) {
        pastDueExamin += 1;
      }
    } else if (isUnitExam) {
      unitExaminAssigned += 1;
      unitExaminCompleted += completed ? 1 : 0;
      if (!completed && isBeforTime(get(k, "dueDate")) && (!k.lateDate || isBeforTime(get(k, "lateDate")))) {
        pastDueUnitExamin += 1;
      }
    } else {
      activityAssigned += 1;
      activityCompleted += completed ? 1 : 0;
      if (!completed && isBeforTime(get(k, "dueDate")) && (!k.lateDate || isBeforTime(get(k, "lateDate")))) {
        pastDueActivity += 1;
      }
    }
  }

  return {
    activity: {
      activityAssigned: activityAssigned,
      activityCompleted: activityCompleted,
      pastDueActivity: pastDueActivity,
    },
    examin: {
      examinAssigned: examinAssigned,
      examinCompleted: examinCompleted,
      pastDueExamin: pastDueExamin,
    },
    unitExamin: {
      unitExaminAssigned: unitExaminAssigned,
      unitExaminCompleted: unitExaminCompleted,
      pastDueUnitExamin: pastDueUnitExamin,
    }
  }
}
//to be remove end
const ProgressRing = memo(({ pct, size, fontSize, gradientId }) => {
  const strokeWidth = 10;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (pct / 100) * circumference;

  return (
    <svg width={size} height={size} aria-hidden>
      <defs>
        <linearGradient
          id={gradientId}
          x1="225"
          y1="114"
          x2="0"
          y2="114"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4D5FFE" />
          <stop offset="1" stopColor="#F75CFA" />
        </linearGradient>
      </defs>
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke="#f3f3fa"
        strokeWidth={strokeWidth}
        fill="none"
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke={`url(#${gradientId})`}
        strokeWidth={strokeWidth}
        fill="none"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
      />
      <text
        x="50%"
        y="54%"
        textAnchor="middle"
        dominantBaseline="middle"
        style={{ fontSize }}
        fontWeight="bold"
        fill="#111"
      >
        {pct}%
      </text>
    </svg>
  );
});

const OverallGradeRing = memo(({ percent, size = 116 }) => {
  const pct = Math.max(0, Math.min(100, Math.round(Number(percent)) || 0));
  return (
    <div style={{ position: "relative", width: size, height: size }}>
      <ProgressRing pct={pct} size={size} fontSize={18} gradientId="overallGradeGradient" />
    </div>
  );
});

const CardItem = memo(({
  title,
  value,
  isAplang,
  subValue,
  max,
  onClick = () => null,
  selected = false,
  ringId,
}) => {
  const pct = max && max > 0 ? Math.round((value / max) * 100) : 0;

  return (
    <div className={`stduntPrgrsInfo ${selected ? "selected" : ""}`} onClick={onClick}>
      <label>{title}</label>
      {!isAplang && <p>{value}</p>}
      {!isAplang && (
        <div
          style={{
            marginTop: 8,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ProgressRing pct={pct} size={116} fontSize={26} gradientId={ringId} />
        </div>
      )}
      <div className="stduntPrgrsLanUpr">
        {isAplang && <div className="stduntPrgrsLan">{value}</div>}
        {isAplang && <div className="stduntPrgrsLan">{subValue}</div>}
      </div>
    </div>
  );
});

const getAssignmentRowKey = (assignment) =>
  assignment?.data?.id ||
  assignment?.session_id ||
  assignment?.activityId ||
  assignment?.quizId ||
  assignment?.id;

const StudentAssignmentRow = memo(({
  assignment,
  isExpanded,
  onToggleExpand,
  fetchAssignmentSubmission,
  booksAllList,
  currentClass,
}) => (
  <AssignmentStatusStudent
    chapter={get(assignment, "data.chapter")}
    data={assignment}
    submission={fetchAssignmentSubmission(assignment)}
    showResponce={isExpanded}
    onShowResponce={onToggleExpand}
    book={get(assignment, "book")}
    booksAllList={booksAllList}
    currentClass={currentClass}
    assignment={assignment}
  />
));


function filterUniqueBySessionId(assignments, class_game_activity) {
  const seenSessionIds = new Set();

  return [...assignments, ...class_game_activity].filter((item) => {
    if (item.session_id) {
      if (seenSessionIds.has(item.session_id)) {
        return false;
      }
      seenSessionIds.add(item.session_id);
      return true;
    }
    return true;
  });
}

const StudentVisuals = ({
  currentUser,
  submissions,
  booksAllList,
  assignments,
  selectedUser,
}, ref) => {
  const { class_game_activity, fetchClassGameActivity } =
    useClassGameActivity();
  const assignment_data = useMemo(
    () => filterUniqueBySessionId(assignments, class_game_activity),
    [class_game_activity, assignments]
  );
  const dispatch = useDispatch();
  // const navigate = useNavigate();
  const parentOrgId = useParentOrgId();
  const currentSem = getCurrenSem(parentOrgId);
  const resources = useResources();
  const servertime = useServertime();
  const timezone = useOrgTimezone();
  const exams = useExams();
  const apexams = useApExams();
  const story = useStory();
  const allresourcesVideo = useMemo(
    () => flatMap(map(resources, (k) => k.videos)),
    [resources]
  );
  const submissionsByAssignmentId = useMemo(() => {
    const lookup = new Map();
    submissions?.forEach((submission) => {
      if (submission?.assignmentId) {
        lookup.set(submission.assignmentId, submission);
      }
    });
    return lookup;
  }, [submissions]);
  const booksById = useMemo(() => {
    const lookup = new Map();
    booksAllList?.forEach((book) => {
      if (book?.id) {
        lookup.set(book.id, book);
      }
    });
    allresourcesVideo?.forEach((video) => {
      if (video?.id) {
        lookup.set(video.id, video);
      }
    });
    return lookup;
  }, [booksAllList, allresourcesVideo]);
  const [loading, setLoading] = useState(true);
  const [section, setSection] = useState("all");
  const [sectionSort, setSectionSort] = useState("all");
  const [bookSelection, setBookSelection] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [expandedAssignmentId, setExpandedAssignmentId] = useState(null);
  const [activityPage, setActivityPage] = useState(1);
  const assignmentListRef = useRef(null);
  const [isdropdown, setIsDropdown] = useState(false);
  const [activeSem, setActiveSem] = useState(currentSem);
  const [cardSelected, setCardSelected] = useState("");
  const [filterRef, isFilterVisible, setIsFilterVisible] =
    useComponentVisibleHook(false);
  const [bookfilterRef, isBookFilterVisible, setIsBookFilterVisible] =
    useComponentVisibleHook(false);
  const [sortfilterRef, isSortFilterVisible, setIsSortFilterVisible] =
    useComponentVisibleHook(false);
  const dropdownContentRef = useRef(null);
  const bookDropdownContentRef = useRef(null);
  const sortDropdownContentRef = useRef(null);
  const [viewType, setViewType] = useState("all");
  const gradeChartSize = typeof window !== "undefined" && window.innerWidth < 1025 ? 80 : 116;

  const handleViewTypeChange = (e) => {
    setViewType(e.target.value);
  };

  useEffect(() => {
    if (cardSelected !== "") {
      setViewType("all");
    }
  }, [cardSelected]);
  
  useEffect(() => {
    try {
      if (dropdownContentRef.current) {
        if (!isFilterVisible) {
          dropdownContentRef.current.scrollTop = 0;
        } else {
          setTimeout(() => {
            if (dropdownContentRef.current) {
              dropdownContentRef.current.scrollTop = 0;
            }
          }, 0);
        }
      }
      
    } catch (error) {
      Sentry.captureException(error);
    }
 
  }, [isFilterVisible]);
  
  useEffect(() => {
    if (bookDropdownContentRef.current) {
      if (!isBookFilterVisible) {
        bookDropdownContentRef.current.scrollTop = 0;
      } else {
        setTimeout(() => {
          if (bookDropdownContentRef.current) {
            bookDropdownContentRef.current.scrollTop = 0;
          }
        }, 0);
      }
    }
  }, [isBookFilterVisible]);
  
  useEffect(() => {
    if (sortDropdownContentRef.current) {
      if (!isSortFilterVisible) {
        sortDropdownContentRef.current.scrollTop = 0;
      } else {
        setTimeout(() => {
          if (sortDropdownContentRef.current) {
            sortDropdownContentRef.current.scrollTop = 0;
          }
        }, 0);
      }
    }
  }, [isSortFilterVisible]);
  
  const currentClass = useCurrentClass();
  const [openGradebook, setOpenGradebook] = useState(false);
  const userAllowedBooks = useUserAllowedBooks()
  const allowed_books = useCurrentClassBook();
  const { activeStudentParent } = useActiveStudentofParent();
  const { allowedbooks } = useCurrentClassActiveBooks();

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      if (currentUser?.id) {
        await Promise.allSettled([
         // dispatch(handleListUserNotes(currentUser?.id)),
          dispatch(
            handleListUserSubmissionsByClass(
              currentUser?.id,
              currentClass?.id
            )
          ),
          fetchClassGameActivity(),
        ]);
        const getAssignmentCount = await dispatch(
          handleGetStudentAssignmentCount(currentClass?.id)
        );
        // setTotalAssignmentCount(getAssignmentCount);
        localStorage.setItem(
          "gradebookUserId",
          currentUser?.id ?? "nocurrentuser"
        );
      }
      setLoading(false);
    }
    fetchData();
  }, [currentUser]);
  const getWeightedGrade = (grade, weight) => {
    if (weight === 0) {
      return 0;
    }
    return (grade * weight) / 100;
  };
  const getGrade = (submission) => {
    let isTbgObj = checkIsManualGradable(
      get(submission, "assignment.questions")
    );
    let bg_text 
    if (currentUser?.role === 'student') {
      bg_text = 'TBG';
    } else {
       bg_text =
      submission && submission.ai_grade && submission.ai_grade.length > 0
        ? "TBG - AI"
        : "TBG";
    }
    // const bg_text = "TBG - AI";
    return submission?.manualGrading && isTbgObj
      ? bg_text
      : submission?.grade
      ? submission?.grade
      : 0;
  };
  const sortByDueDate = (arr) => {
    return orderBy(arr, ["dueDate"], ["desc"]);
  };
  const getAssignmentDate = (assignment) => {
    if (assignment) {
      if (assignment.lateDate && assignment.lateDate.length > 0) {
        return assignment.lateDate;
      } else {
        return assignment.dueDate;
      }
    } else {
      return null;
    }
  };
  const filterCompletedAssignment = (assignment) => {
    if (!assignment) return false;
    return (
      assignment.submission &&
      assignment.submission.complete &&
      !assignment.retaking
    );
  };
  const checkNotCompleted = (assignment) => {
    return (
      (get(assignment, "submission.submissions", 0) <=
        get(assignment, "retakes", 0) ||
        get(assignment, "submission.retaking")) &&
      !(
        get(assignment, "submission.submissions", 0) == 0 &&
        !get(assignment, "submission.retaking")
      )
    );
  };
  const filterPastdueAssignment = (assignment) => {
    if (!assignment) return false;
    const isCompleted =
      has(assignment, "submission.complete") &&
      get(assignment, "submission.complete", true);
    return !!(
      isBeforTime(assignment.dueDate, servertime, timezone) && !isCompleted
    );
  };
  const filterInCompleteAssignment = (assignment) => {
    if (!assignment) return false;
    return (
      !isBeforTime(getAssignmentDate(assignment), servertime, timezone) &&
      (get(assignment, "submission.submissions", 0) == 0 ||
        get(assignment, "submission.retaking"))
    );
  };
  const filterInRetakeAssignment = (assignment) => {
    if (!assignment) return false;
    const isNotCompleted = checkNotCompleted(assignment);
    const has_time = !isBeforTime(
      getAssignmentDate(assignment),
      servertime,
      timezone
    );
    const has_submission = get(assignment, "submission.submissions", 0) > 0;
    const has_retaking = !get(assignment, "submission.retaking");
    return isNotCompleted && has_time && has_submission && has_retaking;
  };
  const filterTodayAssignment = (assignment) => {
    if (!assignment) return false;
    const _lateDate = get(assignment, "lateDate");
    const _dueDate = get(assignment, "dueDate");
    const isCompleted =
      has(assignment, "submission.complete") &&
      get(assignment, "submission.complete", true);
    return (
      (moment(_lateDate).isSame(moment(), "days") ||
        moment(_dueDate).isSame(moment(), "days")) &&
      !isCompleted
    );
  };
  const filterWeekAssignment = (assignment) => {
    if (!assignment) return false;
    const _lateDate = get(assignment, "lateDate");
    const _dueDate = get(assignment, "dueDate");
    if (!_lateDate) return false;
    const isCompleted =
      has(assignment, "submission.complete") &&
      get(assignment, "submission.complete", true);
    const now = moment();
    const isDueThisWeek = _dueDate && moment(_dueDate).isSame(now, "week") && moment(_dueDate).isSameOrAfter(now, "day");
    const isLateThisWeek = _lateDate && moment(_lateDate).isSame(now, "week") && moment(_lateDate).isSameOrAfter(now, "day");      
    return (isDueThisWeek || isLateThisWeek) && !isCompleted;
  };

  const filterStartWeekAssignment = (assignment) => {
    if (!assignment) return false;
    const _dueDate = get(assignment, "scheduleAt");
    return moment(_dueDate).isSame(moment(), "week");
  };

  const filterWeekAssignmentPast = (assignment) => {
    if (!assignment) return false;
    const _dueDate = get(assignment, "lateDate");
    return moment(_dueDate).isSame(moment(), "week");
  };

  const semAssignment = useMemo(() => {
    const userAssignment = getUserAssignment(
      allowed_books,
      assignment_data,
      currentUser,
      currentClass,
      userAllowedBooks?.other_permissions?.resourses,
      activeStudentParent
    );
    const withSubmission = map(userAssignment, (assignment) => {
      const is_game = assignment.type === "game";
      const is_debate = assignment.type === "debate";
      const is_worksheet = assignment.type === "worksheet";
      const is_loteria = assignment.type === "bingo";
      const chapter_id =
        is_debate || is_game || is_loteria || is_worksheet
          ? get(assignment, "assignment.chapter")
          : get(assignment, "data.chapter");
      const assignmentId =
        is_debate || is_game || is_loteria || is_worksheet
          ? get(assignment, "session_id")
          : get(assignment, "data.id");
      let book = booksById.get(chapter_id);
      try {
        if (!book) {
          if (isVideo(get(assignment, "data.chapter"), resources)) {
            book = booksById.get(chapter_id?.substring(0, 36));
          }
        }
      } catch (error) {
        Sentry.captureException(`555 Error in getUserAssignment: ${error}`);
      }
      let submission = submissionsByAssignmentId.get(assignmentId);
      if (
        submission &&
        (!submission.assignment || Object.keys(submission.assignment).length === 0)
      ) {
        submission = {
          ...submission,
          assignment: assignment.assignment,
        };
      }
      return {
        ...assignment,
        submission,
        data:
          is_game || is_debate || is_loteria || is_worksheet
            ? assignment.assignment
            : assignment.data,
        book: book ? book : {},
      };
    });
    let assignmentWithSubmission = filter(withSubmission, "book");
    const isSpecial = parentOrgId && ['e5dcb06f-f78d-457a-bacf-8fa357b38ee2', '37ae9554-0da4-4d62-b04f-ec500b0275a4'].includes(parentOrgId);
    
    const semData = {};
    
    assignmentWithSubmission.forEach(assignment => {
      const assignmentDate = moment(assignment.dueDate);
      const assignmentYear = assignmentDate.year();
      const assignmentMonth = assignmentDate.month();
      const assignmentDay = assignmentDate.date();
      
      let sem1Year, sem2Year;
      let sem1StartDate, sem1EndDate, sem2StartDate, sem2EndDate;
      
      if (isSpecial) {
        const sem1EndDay = getSem1EndDate(parentOrgId);
        const sem2StartDay = getSem2StartDate(parentOrgId);
        if (assignmentMonth === 0 && assignmentDay <= sem1EndDay) {
          sem1Year = assignmentYear - 1;
          sem2Year = assignmentYear;
          const sem1Dates = semeterDateByYear(sem1Year, parentOrgId);
          const sem2Dates = semeterDateByYear(sem2Year, parentOrgId);
          sem1StartDate = sem1Dates.sem1StartDate;
          sem1EndDate = sem1Dates.sem1EndDate;
          sem2StartDate = sem2Dates.sem2StartDate;
          sem2EndDate = sem2Dates.sem2EndDate;
        } else if (assignmentMonth === 0 && assignmentDay >= sem2StartDay) {
          sem1Year = assignmentYear - 1;
          sem2Year = assignmentYear;
          const sem1Dates = semeterDateByYear(sem1Year, parentOrgId);
          const sem2Dates = semeterDateByYear(sem2Year, parentOrgId);
          sem1StartDate = sem1Dates.sem1StartDate;
          sem1EndDate = sem1Dates.sem1EndDate;
          sem2StartDate = sem2Dates.sem2StartDate;
          sem2EndDate = sem2Dates.sem2EndDate;
        } else if (assignmentMonth >= 6) {
          sem1Year = assignmentYear;
          sem2Year = assignmentYear;
          const sem1Dates = semeterDateByYear(sem1Year, parentOrgId);
          const sem2Dates = semeterDateByYear(sem2Year, parentOrgId);
          sem1StartDate = sem1Dates.sem1StartDate;
          sem1EndDate = sem1Dates.sem1EndDate;
          sem2StartDate = sem2Dates.sem2StartDate;
          sem2EndDate = sem2Dates.sem2EndDate;
        } else {
          sem1Year = assignmentYear - 1;
          sem2Year = assignmentYear;
          const sem1Dates = semeterDateByYear(sem1Year, parentOrgId);
          const sem2Dates = semeterDateByYear(sem2Year, parentOrgId);
          sem1StartDate = sem1Dates.sem1StartDate;
          sem1EndDate = sem1Dates.sem1EndDate;
          sem2StartDate = sem2Dates.sem2StartDate;
          sem2EndDate = sem2Dates.sem2EndDate;
        }
      } else {
        sem1Year = assignmentYear;
        sem2Year = assignmentYear;
        const dates = semeterDateByYear(assignmentYear, parentOrgId);
        sem1StartDate = dates.sem1StartDate;
        sem1EndDate = dates.sem1EndDate;
        sem2StartDate = dates.sem2StartDate;
        sem2EndDate = dates.sem2EndDate;
      }
      
      let sem1 = semData[getKey(1, sem1Year.toString())] || [];
      let sem2 = semData[getKey(2, sem2Year.toString())] || [];

      if (assignmentDate.isBetween(sem1StartDate, sem1EndDate, 'day', '[]')) {
        sem1.push(assignment);
      } else if (assignmentDate.isBetween(sem2StartDate, sem2EndDate, 'day', '[]')) {
        sem2.push(assignment);
      }
      
      semData[getKey(1, sem1Year.toString())] = sem1;
      semData[getKey(2, sem2Year.toString())] = sem2;
    });
    if (Object.keys(semData).length === 0) {
      return {};
    }

    const sem_data = {};
    const current_year = moment().format("YYYY");
    const prevYear = parseInt(current_year, 10) - 1;
    const semesters = {
      currentYearSem1: getKey(1, current_year),
      currentYearSem2: getKey(2, current_year),
      prevYearSem1: getKey(1, prevYear),
      prevYearSem2: getKey(2, prevYear),
    };

    const addSemData = (key) => {
      if (semData[key]) {
        sem_data[key] = semData[key];
        return true;
      }
      return false;
    };

    sem_data[currentSem] = semData[currentSem];

    if (isSpecial) {
      if (currentSem === semesters.currentYearSem1) {
        addSemData(semesters.currentYearSem2) ||
          addSemData(semesters.prevYearSem1) ||
          addSemData(semesters.prevYearSem2);
      } else if (currentSem === semesters.currentYearSem2) {
        addSemData(semesters.currentYearSem1) ||
          addSemData(semesters.prevYearSem1) ||
          addSemData(semesters.prevYearSem2);
      }
    } else {
      const { sem2StartDate, sem2EndDate } = semeterDateByYear(parseInt(current_year, 10), parentOrgId);
      if (moment().isSameOrAfter(sem2StartDate) && moment().isSameOrBefore(sem2EndDate)) {
        addSemData(semesters.prevYearSem1);
        addSemData(semesters.currentYearSem2);
      } else {
        addSemData(semesters.currentYearSem1);
        addSemData(semesters.currentYearSem2);
      }
    }

    return sem_data;
  }, [
    assignment_data,
    submissionsByAssignmentId,
    booksById,
    resources,
    allowed_books,
    activeStudentParent,
    parentOrgId,
    currentSem,
    currentUser,
    currentClass,
    userAllowedBooks,
  ]);

  const activeSemData = useMemo(
    () => semAssignment[activeSem] || [],
    [semAssignment, activeSem]
  );

  const assignmentBuckets = useMemo(() => {
    const assignmentWithSubmission = semAssignment[activeSem] || [];
    const weekStartAssignment = filter(
      assignmentWithSubmission,
      filterStartWeekAssignment
    );
    const weekAssignmentPast = filter(
      assignmentWithSubmission,
      filterWeekAssignmentPast
    );

    return {
      all: assignmentWithSubmission,
      pastDue: sortByDueDate(filter(assignmentWithSubmission, filterPastdueAssignment)),
      completed: sortByDueDate(filter(assignmentWithSubmission, filterCompletedAssignment)),
      todayPastDue: sortByDueDate(filter(assignmentWithSubmission, filterTodayAssignment)),
      weekPastDue: sortByDueDate(filter(assignmentWithSubmission, filterWeekAssignment)),
      incompleted: sortByDueDate(filter(assignmentWithSubmission, filterInCompleteAssignment)),
      retakes: sortByDueDate(filter(assignmentWithSubmission, filterInRetakeAssignment)),
      startToday: filterStudentSubmission(weekStartAssignment, "start", assignmentWithSubmission),
      missingThisWeek: filterStudentSubmission(
        weekAssignmentPast,
        "missing",
        assignmentWithSubmission
      ),
    };
  }, [semAssignment, activeSem, servertime, timezone]);

  const assignmentInfo = useMemo(
    () => getCardData(currentUser?.id, semAssignment[activeSem], submissions),
    [currentUser?.id, submissions, semAssignment, activeSem]
  );

  const overallGradePercent = useMemo(() => {
    let assignmentCount = 0;
    let total = 0;
    activeSemData.forEach((item) => {
      const grade = getGrade(item.submission);
      if (!Number.isNaN(parseInt(grade, 10))) {
        assignmentCount += 1;
        const weightage = parseInt(item.weightage, 10) || 100;
        total += getWeightedGrade(parseInt(grade, 10), weightage);
      }
    });
    if (!assignmentCount) {
      return 0;
    }
    const grade = Math.round(total / assignmentCount);
    return Number.isNaN(grade) ? 0 : grade;
  }, [activeSemData, currentUser?.role]);

  const activeCardFilter = cardSelected || "all";

  const todayDate = moment();
  const apExamLAN = dayjs("14/05/2026", "DD/MM/YYYY");
  const apExamLIT = dayjs("13/05/2026", "DD/MM/YYYY");

  const getTitle = () => {
    if (section === "all") {
      return "All";
    }
    const obj = find(DROPDOWN, ["value", section]);
    return obj?.label || FILTER_STATUS_LABEL;
  };

  const getSortTitle = () => {
    if (sectionSort === "all") {
      return "None";
    }
    const obj = find(DROPDOWNSORT, ["value", sectionSort]);
    return obj?.label || FILTER_SORT_LABEL;
  };

  const bookForFilter = useMemo(() => {
    let allBook = [
      { bookId: "all", description: "All" },
      { bookId: "debate", description: "Debate" },
      { bookId: "worksheet", description: "Grammar drill" },
      { bookId: "bingo", description: "Lotería" },
      { bookId: "story", description: "Story" },
      { bookId: "ap", description: "AP Exams" },
      { bookId: "exams", description: "Exams" },
      { bookId: "game", description: "1Game" },
    ];
    const filterBooks = [ { bookId: "all", description: "All" } ,...allowedbooks.map(book => ({ bookId: book.id, description: book.description })), ...allBook.slice(1), ];
    return uniqBy(filterBooks, "bookId");
  }, [allowedbooks]);

  const getTitleBookFilterTitle = () => {
    if (bookSelection === "all") {
      return "All";
    }
    const bookData = find(bookForFilter, ["bookId", bookSelection]);
    if (bookData) {
      return get(bookData, "description", "");
    }
    return FILTER_BOOK_LABEL;
  };
  const filterdBasedOnBook = (arr, bookVal) => {
    if (bookVal == "all" || !bookVal) {
      return arr;
    } else if (bookVal === "ap") {
      return filter(arr, (k) =>
        apexams
          ?.flatMap((k) => k.exams)
          .map((n) => `${n.bookId}`)
          .includes(get(k, "data.bookId"))
      );
    } else if (bookVal === "story") {
      return filter(arr, (k) =>
        story?.map((n) => `${n.bookId}`).includes(get(k, "data.bookId"))
      );
    } else if (bookVal === "debate") {
      return filter(arr, (k) => k?.type === "debate");
    } else if (bookVal === "worksheet") {
      return filter(arr, (k) => k?.type === "worksheet");
    } else if (bookVal === "bingo") {
      return filter(arr, (k) => k?.type === "bingo");
    } else if (bookVal === "exams") {
      return filter(arr, (k) =>
        exams
          ?.flatMap((k) => k.exams)
          .map((n) => `${n.bookId}`)
          .includes(get(k, "data.bookId"))
      );
    } else if (bookVal === "game") {
      return filter(arr, (k) => k?.type === "game" || k?.type === "game");
    } else {
      const arrval = filter(
        arr,
        (k) =>
          get(k, "data.bookId") == bookVal || get(k, "data.chapter") == bookVal
      );
      return arrval;
    }
  };

  const onselectionchange = (value, bookVal, type) => {
    setExpandedAssignmentId(null);
    if (type === "book") {
      setIsBookFilterVisible(false);
      setBookSelection(bookVal);
    } else {
      setIsFilterVisible(false);
      setSection(value);
    }
    setIsDropdown(false);
  };

  const onSortSelectionChange = (value, bookVal) => {
    setIsSortFilterVisible(false);
    setSectionSort(value);
    setIsDropdown(false);
  };

  const getNoAssignmentBg = (value) => {
    switch (value) {
      case "all":
        return nothingToSee;
      case "due_today":
        return nothingToSee;
      case "due_this_week":
        return nothingToSee;
      case "due_past":
        return nothingToSee;
      case "completed":
        return nothingToSee;
      case "incompleted":
        return nothingToSee;
      default:
        return nothingToSee;
    }
  };

  const getPastDueAssignment = () => {
    const { pastDue } = assignmentBuckets;
    if (activeCardFilter === "all") {
      return pastDue;
    }
    if (activeCardFilter === "quiz") {
      return pastDue.filter(
        (assignment) =>
          assignment.data?.typeId === "quiz" &&
          !assignment.data?.is_exam &&
          !assignment.data?.is_unit_exam
      );
    }
    if (activeCardFilter === "examen_past") {
      return pastDue.filter((assignment) => assignment.data?.is_exam);
    }
    if (activeCardFilter === "unit_past") {
      return pastDue.filter((assignment) => assignment.data?.is_unit_exam);
    }
    return pastDue.filter((k) => !k?.data?.is_exam && !k?.data?.is_unit_exam);
  };

  const getPastData = (pastDueAssignment) => {
    if (activeCardFilter === "all") {
      return pastDueAssignment;
    }
    if (activeCardFilter === "quiz") {
      return pastDueAssignment.filter(
        (assignment) => assignment.data?.typeId === "quiz"
      );
    }
    if (activeCardFilter === "activity") {
      return pastDueAssignment.filter(
        (assignment) => assignment.data?.typeId === "activity"
      );
    }
    return pastDueAssignment;
  };

  const getCompletedAssignment = () => {
    const { completed } = assignmentBuckets;
    if (activeCardFilter === "all") {
      return completed.filter((k) => !k?.data?.is_exam && !k?.data?.is_unit_exam);
    }
    if (activeCardFilter === "quiz") {
      return completed.filter(
        (assignment) =>
          assignment.data?.typeId === "quiz" &&
          !assignment.data?.is_exam &&
          !assignment.data?.is_unit_exam
      );
    }
    if (activeCardFilter === "activity") {
      return completed.filter(
        (assignment) =>
          assignment.data?.typeId === "activity" &&
          !assignment.data?.is_exam &&
          !assignment.data?.is_unit_exam
      );
    }
    if (activeCardFilter === "activity_completed") {
      return completed.filter((assignment) => assignment.data?.typeId === "activity");
    }
    if (activeCardFilter === "Examen_complete") {
      return completed.filter((assignment) => assignment.data?.is_exam);
    }
    if (activeCardFilter === "unit_completed") {
      return completed.filter((assignment) => assignment.data?.is_unit_exam);
    }
    return completed;
  };

  const getCompletedData = (completedAssignment) => {
    if (activeCardFilter === "all") {
      return completedAssignment;
    }
    if (activeCardFilter === "quiz") {
      return completedAssignment.filter(
        (assignment) => assignment.data?.typeId === "quiz"
      );
    }
    if (activeCardFilter === "activity") {
      return completedAssignment.filter(
        (assignment) => assignment.data?.typeId === "activity"
      );
    }
    return completedAssignment;
  };

  const getInCompletedAssignment = () => {
    const { incompleted } = assignmentBuckets;
    if (activeCardFilter === "all") {
      return incompleted;
    }
    if (activeCardFilter === "quiz") {
      return incompleted.filter((assignment) => assignment.data?.typeId === "quiz");
    }
    if (activeCardFilter === "activity") {
      return incompleted.filter((assignment) => assignment.data?.typeId === "activity");
    }
    return incompleted;
  };

  const getInCompletedData = (incompletedAssignment) => {
    if (activeCardFilter === "all") {
      return incompletedAssignment;
    }
    if (activeCardFilter === "quiz") {
      return incompletedAssignment.filter(
        (assignment) => assignment.data?.typeId === "quiz"
      );
    }
    if (activeCardFilter === "activity") {
      return incompletedAssignment.filter(
        (assignment) => assignment.data?.typeId === "activity"
      );
    }
    return incompletedAssignment;
  };

  const getRetakesData = (retakingAssignment) => {
    if (activeCardFilter === "all") {
      return retakingAssignment;
    }
    if (activeCardFilter === "quiz") {
      return retakingAssignment.filter(
        (assignment) => assignment.data?.typeId === "quiz"
      );
    }
    if (activeCardFilter === "activity") {
      return retakingAssignment.filter(
        (assignment) => assignment.data?.typeId === "activity"
      );
    }
    return retakingAssignment;
  };

  const filteredAssignments = useMemo(() => {
    let baseData = [];
    const sectionObj = find(DROPDOWN, ["value", section]);
    if (sectionObj || bookSelection || section === "all") {
      switch (section) {
        case "all":
          baseData = filterdBasedOnBook(assignmentBuckets.all, bookSelection);
          break;
        case "due_today":
          baseData = filterdBasedOnBook(
            filterActiveTasks(assignmentBuckets.todayPastDue),
            bookSelection
          );
          break;
        case "due_this_week":
          baseData = filterdBasedOnBook(assignmentBuckets.weekPastDue, bookSelection);
          break;
        case "due_past":
          baseData = filterdBasedOnBook(getPastDueAssignment(), bookSelection);
          break;
        case "completed":
          baseData = filterdBasedOnBook(getCompletedAssignment(), bookSelection);
          break;
        case "incompleted":
          baseData = filterdBasedOnBook(getInCompletedAssignment(), bookSelection);
          break;
        case "retakes":
          baseData = filterdBasedOnBook(
            getRetakesData(assignmentBuckets.retakes),
            bookSelection
          );
          break;
        case "startToday":
          baseData = filterdBasedOnBook(assignmentBuckets.startToday, bookSelection);
          break;
        case "missing_this_week":
          baseData = filterdBasedOnBook(assignmentBuckets.missingThisWeek, bookSelection);
          break;
        default:
          baseData = filterdBasedOnBook(assignmentBuckets.all, bookSelection);
          break;
      }
    } else {
      baseData = [...assignmentBuckets.all];
    }

    let filtered = baseData;
    const trimmedSearch = searchQuery.trim().toLowerCase();
    if (trimmedSearch) {
      filtered = baseData.filter((item) =>
        (item.displayName || "").toLowerCase().includes(trimmedSearch)
      );
    }

    switch (sectionSort) {
      case "oldest_to_newest":
        filtered = filtered
          .slice()
          .sort((a, b) => new Date(a.dueDate) - new Date(b.dueDate));
        break;
      case "newest_to_oldest":
        filtered = filtered
          .slice()
          .sort((a, b) => new Date(b.dueDate) - new Date(a.dueDate));
        break;
      case "alphabetical_order":
        filtered = filtered.slice().sort((a, b) => {
          const nameA = (a.displayName || "").toLowerCase();
          const nameB = (b.displayName || "").toLowerCase();
          return nameA.localeCompare(nameB);
        });
        break;
      default:
        break;
    }

    return filtered;
  }, [
    section,
    bookSelection,
    sectionSort,
    searchQuery,
    assignmentBuckets,
    cardSelected,
    apexams,
    exams,
    story,
  ]);

  const applyAllFiltersAndSort = useCallback(
    (_filterSection, _bookVal, _sortType, searchText = "") => {
      if (typeof searchText === "string") {
        setSearchQuery(searchText);
      }
    },
    []
  );

  useImperativeHandle(ref, () => ({
    applyAllFiltersAndSort,
  }));

  useEffect(() => {
    setActivityPage(1);
    setExpandedAssignmentId(null);
  }, [section, bookSelection, sectionSort, searchQuery, activeSem, viewType, cardSelected]);

  const handleActivityPageChange = useCallback((page) => {
    setActivityPage(page);
    setExpandedAssignmentId(null);
    assignmentListRef.current?.scrollTo?.({ top: 0, behavior: "smooth" });
  }, []);

  const fetchAssignmentSubmission = useCallback((assignment) => {
    if (
      assignment?.type === "debate" ||
      assignment.type === "bingo" ||
      assignment.type == "worksheet" ||
      assignment.type === "game"
    ) {
      const assignmentSubmissions = get(assignment, "submission");
      const game = find(class_game_activity, [
        "session_id",
        assignmentSubmissions?.assignmentId,
      ]);
      if (game) {
        const submissionData = {
          ...assignmentSubmissions,
          assignment: game.assignment,
        };
        return submissionData;
      } else {
        return assignmentSubmissions;
      }
    } else {
      return get(assignment, "submission");
    }
  }, [class_game_activity]);

  const displayAssignments = useMemo(() => {
    const hiddenBookIds =
      get(currentClass, "hide_books", []).map((data) => data?.bookId) || [];
    let assignments = filteredAssignments?.filter((assignment) => {
      if (
        get(currentUser, "role") === "student" &&
        hiddenBookIds?.includes(assignment?.book?.id)
      ) {
        return false;
      }
      return Boolean(assignment);
    });

    if (viewType === "quiz") {
      assignments = assignments?.filter((x) => x?.data?.is_exam === true);
    } else if (viewType === "exam") {
      assignments = assignments?.filter((x) => x?.data?.is_unit_exam === true);
    }

    return assignments || [];
  }, [
    filteredAssignments,
    viewType,
    currentUser,
    currentClass?.hide_books,
  ]);

  const paginatedAssignments = useMemo(() => {
    const startIndex = (activityPage - 1) * ACTIVITIES_PAGE_SIZE;
    return displayAssignments.slice(startIndex, startIndex + ACTIVITIES_PAGE_SIZE);
  }, [displayAssignments, activityPage]);

  const totalActivityPages = Math.ceil(
    displayAssignments.length / ACTIVITIES_PAGE_SIZE
  );

  const renderGrades = () => {
    if (displayAssignments.length === 0) {
      return (
        <div className="noAssignImg">
          <NoAssignmentImg src={getNoAssignmentBg(section)} />
        </div>
      );
    }

    return (
      <>
        <SectionContainer ref={assignmentListRef}>
          {map(paginatedAssignments, (assignment) => {
            if (!assignment) return null;
            const rowKey = getAssignmentRowKey(assignment);
            return (
              <StudentAssignmentRow
                key={rowKey}
                assignment={assignment}
                isExpanded={expandedAssignmentId === rowKey}
                onToggleExpand={() =>
                  setExpandedAssignmentId((current) =>
                    current === rowKey ? null : rowKey
                  )
                }
                fetchAssignmentSubmission={fetchAssignmentSubmission}
                booksAllList={booksAllList}
                currentClass={currentClass}
              />
            );
          })}
        </SectionContainer>
        {totalActivityPages > 1 && (
          <PaginationFooter>
            <Pagination
              current={activityPage}
              total={displayAssignments.length}
              pageSize={ACTIVITIES_PAGE_SIZE}
              onChange={handleActivityPageChange}
              showSizeChanger={false}
              showQuickJumper={false}
              showTotal={(total, range) =>
                `${range[0]}-${range[1]} of ${total} activities`
              }
            />
          </PaginationFooter>
        )}
      </>
    );
  };


  return (
    <SentryWrap>
      <Wrapper>
        {loading ? (
        <StudentVisualsSkeleton />
      ) : (
        <>
          <Row className="studentVisualsRow">
            <Col
              xs={{ span: 24 }}
              lg={{ span: 24 }}
              xl={{ span: 17 }}
              style={{ marginBottom: 20 }}
            >
              <div className="ovrAllGrade">
                <div className="ovrAllGradeCmn ovrAllGradeLeft 11">
                  <OverallGradeRing
                    percent={overallGradePercent}
                    size={gradeChartSize}
                  />
                  <div>
                    <p>This is your overall grade for this class</p>
                  </div>
                </div>

                <div className="ovrAllGradeCmn ovrAllGradeRght">
                  <div className="ovrAllGradeRghtIner">
                    <SearchByTitle>Search by</SearchByTitle>

                    <div className="ovrAllGradeDrop">
                      <FilterField>
                        <FilterFieldLabel>{FILTER_STATUS_LABEL}</FilterFieldLabel>
                        <DropdownContainer ref={filterRef}>
                          <Dropdown
                            onClick={() => {
                              setIsFilterVisible(!isFilterVisible);
                              setIsDropdown(!isdropdown);
                            }}
                          >
                            <DropdownTitle>{getTitle()}</DropdownTitle>
                            <DropdownIcon>
                              {isdropdown && isFilterVisible ? (
                                <KeyboardArrowUp />
                              ) : (
                                <KeyboardArrowDown />
                              )}
                            </DropdownIcon>
                          </Dropdown>
                          <DropdownContent ref={dropdownContentRef} show={isFilterVisible} className="setDropDownHght">
                            {DROPDOWN.map((x) => (
                              <DropdownItem
                                key={x.value}
                                $isSelected={x.value === section}
                                onClick={() =>
                                  onselectionchange(x.value, bookSelection)
                                }
                              >
                                {x.label}
                              </DropdownItem>
                            ))}
                          </DropdownContent>
                        </DropdownContainer>
                      </FilterField>

                      <FilterField>
                        <FilterFieldLabel>{FILTER_BOOK_LABEL}</FilterFieldLabel>
                        <DropdownContainer ref={bookfilterRef}>
                          <BookDropdownTrigger
                            onClick={() => {
                              setIsBookFilterVisible(!isBookFilterVisible);
                              setIsDropdown(!isdropdown);
                            }}
                          >
                            <DropdownTitle>
                              {getTitleBookFilterTitle()}
                            </DropdownTitle>
                            <DropdownIcon>
                              {isdropdown && isBookFilterVisible ? (
                                <KeyboardArrowUp />
                              ) : (
                                <KeyboardArrowDown />
                              )}
                            </DropdownIcon>
                          </BookDropdownTrigger>
                          <DropdownContent ref={bookDropdownContentRef} show={isBookFilterVisible} className="setDropDownHght">
                            {map(bookForFilter, (x) => (
                              <DropdownItem
                                key={x?.bookId}
                                $isBook
                                $isSelected={x?.bookId === bookSelection}
                                onClick={() =>
                                  onselectionchange(section, x?.bookId, "book")
                                }
                              >
                                {get(x, "description")}
                              </DropdownItem>
                            ))}
                          </DropdownContent>
                        </DropdownContainer>
                      </FilterField>

                      <FilterField>
                        <FilterFieldLabel>{FILTER_SORT_LABEL}</FilterFieldLabel>
                        <DropdownContainer ref={sortfilterRef}>
                          <Dropdown
                            onClick={() => {
                              setIsSortFilterVisible(!isSortFilterVisible);
                              setIsDropdown(!isdropdown);
                            }}
                          >
                            <DropdownTitle>{getSortTitle()}</DropdownTitle>
                            <DropdownIcon>
                              {isdropdown && isSortFilterVisible ? (
                                <KeyboardArrowUp />
                              ) : (
                                <KeyboardArrowDown />
                              )}
                            </DropdownIcon>
                          </Dropdown>
                          <DropdownContent ref={sortDropdownContentRef} show={isSortFilterVisible} className="setDropDownHght">
                            {map(DROPDOWNSORT, (x) => (
                              <DropdownItem
                                key={x.value}
                                $isSelected={x.value === sectionSort}
                                onClick={() =>
                                  onSortSelectionChange(x.value, bookSelection)
                                }
                              >
                                {get(x, "label")}
                              </DropdownItem>
                            ))}
                          </DropdownContent>
                        </DropdownContainer>
                      </FilterField>
                    </div>
                  </div>
                </div>
              </div>

              <div className="stdntTabsCollect">
                <div className="stdntTabsLeft" style={{display:"flex"}}>
                  {Object.keys(semAssignment).map((key, index) => {
                    return (
                      <Tab
                        active={key == activeSem}
                        key={key}
                        onClick={() => {
                          setActiveSem(key);
                        }}
                      >
                        {key}
                      </Tab>
                    );
                  })}
                </div>
              <div className="studentActivityDropdwon">
                <div className="studentActivityDropdwonItem">
                  <FormControl>
                    <InputLabel id="view-type-select-label">Activity Type</InputLabel>
                    <Select
                      labelId="view-type-select-label"
                      id="view-type-select"
                      value={viewType}
                      disabled={cardSelected != ''}
                      aria-label="Activity Type"
                      label="Activity Type"
                      onChange={handleViewTypeChange}
                      placeholder="Select Actiivty Type"
                      inputProps={{
                        'aria-label': 'Activity Type',
                      }}
                      style={cardSelected != '' ? { backgroundColor: '#f0f0f0'} : {}}
                      getPopupContainer={(trigger) => trigger.parentNode}
                    >
                      <MenuItem value="all">Select All</MenuItem>
                      <MenuItem value="exam">Unit Exam</MenuItem>
                      <MenuItem value="quiz">Examen</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <div
                  className="stdntTabsRght"
                  onClick={() => {
                    setOpenGradebook(!openGradebook);
                  }}
                >
                  {openGradebook ? (
                    <img
                      src={
                        tableViewSvg
                      }
                      alt=""
                    />
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_8_604)">
                        <path
                          d="M9.67 0C12.34 0 14.76 1.08 16.51 2.83C18.26 4.58 19.34 7 19.34 9.67C19.34 12.34 18.26 14.76 16.51 16.51C14.76 18.26 12.34 19.34 9.67 19.34C7 19.34 4.58 18.26 2.83 16.51C1.08 14.76 0 12.34 0 9.67C0 7 1.08 4.58 2.83 2.83C4.58 1.08 7 0 9.67 0Z"
                          fill="#E64C3C"
                        />
                        <path
                          d="M13.9802 13.33L10.0802 5.6C10.0402 5.51 9.97019 5.44 9.88019 5.39C9.65019 5.28 9.38019 5.37 9.27019 5.59L5.37019 13.32C5.26019 13.55 5.35019 13.82 5.57019 13.93C5.80019 14.04 6.07019 13.95 6.18019 13.73L7.85019 10.42H11.4902L13.1602 13.73C13.2702 13.96 13.5502 14.05 13.7702 13.93C14.0002 13.82 14.0802 13.54 13.9702 13.32L13.9802 13.33ZM8.31019 9.51L9.67019 6.81L11.0302 9.51H8.31019Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_8_604">
                          <rect width="19.34" height="19.34" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  )}
                  <label>
                    {openGradebook ? "View as table" : "View as gradebook"}
                  </label>
                </div>
              </div>
                
              </div>

              {/* Student GradeBook  */}
              {openGradebook ? (
                <StudentGradebook
                  sectionSort={sectionSort}
                  filteredAssignments={filteredAssignments}
                  booksAllList={booksAllList}
                  fetchAssignmentSubmission={fetchAssignmentSubmission}
                  viewType={viewType}
                />
              ) : (
                <WrapperSec1>
                  {renderGrades()}
                </WrapperSec1>
              )}
              {/* End of GradeBook */}
            </Col>
            {/* Right Side Assignment Status */}
            <Col
              xs={{ span: 24 }}
              lg={{ span: 24 }}
              xl={{ span: 7 }}
              className="quizCardSection"
            >
            
              <div className="quizCardSectionSet">
                <CardItem
                  ringId="cardActivityCompleted"
                  title={<>Activities<br/>Completed</>}
                  value={assignmentInfo.activity.activityCompleted}
                  onClick={() => {
                    if (cardSelected === 'activity_completed') {
                      onselectionchange("all", bookSelection);
                      setCardSelected('');
                    } else {
                      onselectionchange("completed", bookSelection);
                      setCardSelected('activity_completed');
                    }
                  }}
                  max={assignmentInfo.activity.activityAssigned}
                  selected={cardSelected === 'activity_completed'}
                />
              </div>

              <div className="quizCardSectionSet">
                <CardItem
                  ringId="cardActivityPastDue"
                  title={<>Activities<br/>Past due</>}
                  value={assignmentInfo.activity.pastDueActivity}
                  onClick={() => {
                    if (cardSelected === 'activity_past_due') {
                      onselectionchange("all", bookSelection);
                      setCardSelected('');
                    } else {
                      onselectionchange("due_past", bookSelection);
                      setCardSelected('activity_past_due');
                    }
                  }}
                  max={assignmentInfo.activity.activityAssigned}
                  selected={cardSelected === 'activity_past_due'}
                />
              </div>

              <div className="quizCardSectionSet">
                <CardItem
                  ringId="cardExamenCompleted"
                  title={"Exams\n completed"}
                  value={assignmentInfo.examin.examinCompleted}
                  onClick={() => {
                    if (cardSelected === 'Examen_complete') {
                      onselectionchange("all", bookSelection);
                      setCardSelected('');
                    } else {
                      onselectionchange("completed", bookSelection);
                      setCardSelected('Examen_complete');
                    }
                  }}
                  max={assignmentInfo.examin.examinAssigned}
                  selected={cardSelected === 'Examen_complete'}
                />
              </div>

              <div className="quizCardSectionSet">
                <CardItem
                  ringId="cardExamenPastDue"
                  title={"Exams\n past due"}  
                  value={assignmentInfo.examin.pastDueExamin}
                  onClick={() => {
                    if (cardSelected === 'examen_past') {
                      onselectionchange("all", bookSelection);
                      setCardSelected('');
                    } else {
                      onselectionchange("due_past", bookSelection);
                      setCardSelected('examen_past');
                    }
                  }}
                  max={assignmentInfo.examin.examinAssigned}
                  selected={cardSelected === 'examen_past'}
                />
              </div>

              <div className="quizCardSectionSet">
                <CardItem
                  ringId="cardUnitCompleted"
                  title={"Unit Exam\n completed"}
                  value={assignmentInfo.unitExamin.unitExaminCompleted}
                  onClick={() => {
                    if (cardSelected === 'unit_completed') {
                      onselectionchange("all", bookSelection);
                      setCardSelected('');
                    } else {
                      onselectionchange("completed", bookSelection);
                      setCardSelected('unit_completed');
                    }
                  }}
                  max={assignmentInfo.unitExamin.unitExaminAssigned}
                  selected={cardSelected === 'unit_completed'}
                />
              </div>

              <div className="quizCardSectionSet">
                <CardItem
                  ringId="cardUnitPastDue"
                  title={"Unit Exam\n past due"}
                  value={assignmentInfo.unitExamin.pastDueUnitExamin}
                  onClick={() => {
                    if (cardSelected === 'unit_past') {
                      onselectionchange("all", bookSelection);
                      setCardSelected('');
                    } else {
                      onselectionchange("due_past", bookSelection);
                      setCardSelected('unit_past');
                    }
                  }}
                  max={assignmentInfo.unitExamin.unitExaminAssigned}
                  selected={cardSelected === 'unit_past'}
                />
              </div>

              <div className="quizCardSectionSet daysApExam">
                <CardItem
                  ringId="cardApExamDays"
                  title={"Days until exam"}
                  value={
                    <>
                      <span>
                        {Math.max(0, apExamLAN.diff(todayDate, "days"))} AP
                      </span>
                      <span>SPAN LAN</span>
                    </>
                  }
                  subValue={
                    <>
                      <span>
                        {Math.max(0, apExamLIT.diff(todayDate, "days"))} AP
                      </span>
                      <span>SPAN LIT</span>
                    </>
                  }
                  isAplang={true}
                  max={100}
                />
              </div>
            </Col>
          </Row>
        </>
      )}
      </Wrapper>
    </SentryWrap>
  );
};

const mapStateToProps = (state) => ({
  notes: state.notes,
  currentUser: state.currentUser,
  submissions: state.submissions,
  booksAllList: state.booksAllList,
});

export default connect(mapStateToProps, null, null, { forwardRef: true })(forwardRef(StudentVisuals));
